const AguaSaladaCard = ({ value }) => {

  return (
    <>
      <th scope="row">{value.idNodo}</th>
      <td>{value.lat}</td>
      <td>{value.lon}</td>
      <td>{value.temperatura}</td>
      <td>{value.turbidez}</td>
      <td>{value.conductividad}</td>
      <td>{value.intensidad}</td>
      <td>{value.pH}</td>
      <td>{value.oleaje}</td>
      <td>{value.salinidad}</td>
      <td>{value.fecha}</td>
      <td>{value.hora}</td>
    </>
  )

}

export default AguaSaladaCard